import { EOrganizationPlan } from 'types/enum'

export function isInternalOrganizationPlan(
  plan: EOrganizationPlan | undefined,
): boolean {
  return plan === EOrganizationPlan.INTERNAL
}
